import React, { Suspense } from "react";
import { render } from "react-dom";
import App from "./App";
import Spinner from "./components/Spinner/Spinner";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import "./index.css";

render(
  <I18nextProvider i18n={i18n}>
    <Suspense fallback={<Spinner />}>
      <App />
    </Suspense>
  </I18nextProvider>,
  document.querySelector("#profile-root")
);
